import React, { Component } from "react";
import { Grid } from "@material-ui/core";
import Header from "../../components/Header";
import connect from "react-redux/es/connect/connect";
import { FIND_CHEF } from "../../graphql/queries/chef";
import { compose, graphql } from "react-apollo";
import SearchField from "../../components/Field";
import ChefList from "../../components/Chefs/chefList";
import ChefFilters from "../../components/Filters";
import Button from "@material-ui/core/Button/Button";
import {client} from "../../config/apollo";
import { FilterList, KeyboardArrowLeft } from "@material-ui/icons";
import CircularProgress from "@material-ui/core/CircularProgress";
import { getChefFilters, setChefSearchByName } from "../../redux/chefs";
import Breadcrumbs from "../../components/Breadcrumbs";

class Chefs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openFilters: false,
      showMessage: false,
      searchVal: '',
      chefs: null
    };
  }

  componentDidMount() {
    const { dispatch, chefSearchName } = this.props;

    dispatch(getChefFilters());
    if (!!chefSearchName && chefSearchName !== 'a' && chefSearchName.length > 2) {
      this.setState({ searchVal: chefSearchName }, () => {
        this.searchByName(chefSearchName);
        if (document.getElementById('chef-search')) {
          document.getElementById('chef-search').value = chefSearchName;
        }
      });
    } else {
      this.getChefData();
    }
  }

  getChefData = () => {
    client.query({
      query: FIND_CHEF,
      variables: {
        filters: this.props.exFilters ? {
          engagementSize: this.props.exFilters.engagement || 1,
          priceMin: this.props.exFilters.priceMin || 50,
          priceMax: this.props.exFilters.priceMax || 1000,
          dishes: this.props.exFilters.dishes || [],
          cuisines: this.props.exFilters.cuisines || [],
        } : {
          search: this.props.location.state ? this.props.location.state.search : this.props.location.search ? this.props.location.search.substr(3) :
            this.props.chefSearchName && this.props.chefSearchName.length > 2 ? this.props.chefSearchName : "",
          searchType: "CHEF_NAME"
        },
        pageSize: 10000,
        includeChefs: true
      },
      fetchPolicy: "network-only"
    }).then(response => {
      this.setState({ chefs: response.data.findChefs });
    }).catch(err => console.error('ERR FETCHING CHEFS: ', err));
  };

  closeFilters = () => {
    this.setState({ openFilters: false });
  };

  searchByName = search => {
    const { exFilters, dispatch } = this.props;
    const { searchVal } = this.state;
    const {
      engagement: engagementSize,
      priceMin,
      priceMax,
      cuisines,
      dishes
    } = exFilters || {};

    if (search && search.length <= 2) {
      return;
    }

    let chefFilters = {
      search: searchVal,
      searchType: "CHEF_NAME"
    };

    if (engagementSize > 1) {
      chefFilters = { ...chefFilters, engagementSize };
    }
    if (priceMin > 50) {
      chefFilters = {...chefFilters, priceMin};
    }
    if (priceMax > 50 && priceMax > priceMin && priceMin !== 50 && priceMax !== 1000) {
      chefFilters = { ...chefFilters, priceMax };
    }

    if (!!cuisines && cuisines.length > 0) {
      chefFilters = { ...chefFilters, cuisines };
    }
    if (!!dishes && dishes.length > 0) {
      chefFilters = { ...chefFilters, dishes };
    }

    if (chefFilters.search.length <= 2 || chefFilters.search === "") {
      window.history.replaceState({}, document.title, "/chef-search");
      this.getChefData();
      dispatch(setChefSearchByName('a'));
      return;
    } else {
      dispatch(setChefSearchByName(chefFilters.search));
      window.history.replaceState({}, document.title, "/chef-search?a="+chefFilters.search);
      client.query({
        query: FIND_CHEF,
        variables: {
          filters: chefFilters,
          pageSize: 10000,
          includeChefs: true
        },
        fetchPolicy: "network-only"
      }).then(response => {
        this.setState({ chefs: response.data.findChefs });
        setTimeout(() => {
          window.history.replaceState({}, document.title, "/chef-search");
        }, 3000);
      }).catch(err => console.error('ERR FETCHING CHEFS: ', err));
    }
  };

  applyFilters = filters => {
    const { chefs } = this.props;
    const {
      engagement: engagementSize,
      priceMin,
      priceMax,
      cuisines,
      dishes
    } = filters;

    let chefFilters = {};
    if (engagementSize > 0) {
      chefFilters = { ...chefFilters, engagementSize };
    }
    if (priceMin > 49) {
      chefFilters = {...chefFilters, priceMin};
    }
    if (priceMax > 50 && priceMax > priceMin) {
      chefFilters = { ...chefFilters, priceMax };
    }

    if (cuisines.length > 0) {
      chefFilters = { ...chefFilters, cuisines };
    }
    if (dishes.length > 0) {
      chefFilters = { ...chefFilters, dishes };
    }

    client.query({
      query: FIND_CHEF,
      variables: {
        filters: chefFilters,
        pageSize: 10000,
        includeChefs: true
      },
      fetchPolicy: "network-only"
    }).then(response => {
      this.setState({ chefs: response.data.findChefs });
      const allInputs = document.getElementsByTagName("input");
      for (let i = 0; i < allInputs.length; i++) {
        const placeholder = allInputs[i].placeholder;
        const value = allInputs[i].value;

        if (placeholder === "Search chefs" && value.length > 0) {
          allInputs[i].value = "";
        }
      }
    }).catch(err => console.error('ERR FETCHING CHEFS: ', err));
    // this.setState({ openFilters: false });
  };

  render() {
    const { chefSearchName, dispatch } = this.props;

    const { chefs } = this.state;
    let name = chefSearchName && chefSearchName.length > 2 ? chefSearchName : '';


    return (
      <div>
        <Header {...this.props} />
        <Grid container className="dish-container">
          <Grid container className="chef-details-bc" alignContent={"flex-end"} justify={"space-between"}>
            <Breadcrumbs childRoutes={[
              {
                display: 'Chefs',
                link: 'home/chef-search'
              }
            ]} />
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
              {this.state.showMessage && <div style={{ color: '#ff8000', marginBottom: 10 }}>Press Enter key to search</div>}
            <SearchField
              id={"chef-search"}
              type={"search"}
              placeholder={"Search chefs"}
              onChange={evt => {
                name = evt.target.value;
                this.setState({ searchVal: evt.target.value });
              }}
              onKeyDown ={evt => {
                if (evt.key === 'Backspace') {
                  dispatch(setChefSearchByName('a'));
                }
                if (this.state.searchVal.trim().length > 1) {
                  this.setState({ showMessage: true });
                } else { this.setState({ showMessage: false }); }
              }}
              onKeyPress={evt => {
                if (evt.key === "Enter") {
                  this.searchByName(name);
                  if (name.length) dispatch(setChefSearchByName(name));
                }
                if (this.state.searchVal.trim().length > 1) {
                  this.setState({ showMessage: true });
                } else { this.setState({ showMessage: false }); }
              }}
              value={name}
            />
            </div>
          </Grid>
          <ChefList
            history={this.props.history}
            chefs={chefs ? chefs.chefs : []}
            loading={this.props.chefs.loading}
            searching={true}
          />
          {this.props.chefs.loading && (
            <Grid item md={12} style={{ textAlign: "center" }}>
              <CircularProgress size={50} />
            </Grid>
          )}
        </Grid>
        <ChefFilters
          chefs
          openFiltersDrawer={this.state.openFilters}
          onApplyFilters={this.applyFilters}
          closeFilters={this.closeFilters}
        />
        <Button
         data-test-id={"searchbtn-id"}
          color={"primary"}
          variant={"contained"}
          style={{
            height: 150,
            width: 10,
            borderRadius: 15,
            position: "fixed",
            top: "50%",
            left: "-15px",
            zIndex: 99999
          }}
          onClick={() =>
            this.setState({ openFilters: !this.state.openFilters })
          }
        >
          {this.state.openFilters && (
            <KeyboardArrowLeft style={{ fontSize: 40, color: "white" }} />
          )}
          {!this.state.openFilters && (
            <FilterList style={{ fontSize: 32, color: "white", marginLeft: 3 }} />
          )}
        </Button>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    exFilters: state.chefs.filters,
    userId: state.auth.userId,
    chefSearchName: state.chefs.chefSearchName
  };
};
const ChefSearchWithData = compose(
  graphql(FIND_CHEF, {
    name: "chefs",
    options: props => ({
      variables: {
        filters: props.exFilters ? {
          engagementSize: props.exFilters.engagement || 1,
          priceMin: props.exFilters.priceMin || 50,
          priceMax: props.exFilters.priceMax || 1000,
          dishes: props.exFilters.dishes || [],
          cuisines: props.exFilters.cuisines || [],
        } : {
          search: props.location.state ? props.location.state.search : props.location.search ? props.location.search.substr(3) : props.chefSearchName && props.chefSearchName.length > 2 ? props.chefSearchName : "",
          searchType: "CHEF_NAME"
        },
        pageSize: 10000,
        includeChefs: true
      },
      fetchPolicy: "network-only"
    })
  })
)(Chefs);
const ChefSearch = connect(mapStateToProps)(ChefSearchWithData);

export default ChefSearch;
